import { FormattedMessage } from 'react-intl';
import React from 'react';
import { RETURNS_VIEW_ID, RETURNS_ADVANCED_SEARCH_VIEW_ID } from './view-id-constants';

export const ReturnsAdvancedSearch = {
  label: <FormattedMessage defaultMessage='Advanced Search' description='ordersPage.nav.advancedSearch' id='bw18Xd' />,
  id: RETURNS_ADVANCED_SEARCH_VIEW_ID,
  navigationOverride: '/shipments/returns/advanced-search',
  parentId: RETURNS_VIEW_ID,
};
